class Sticky {
  constructor(options = {}) {
    this.config = {
      stickyElement: null,
      velocity: null,
      ...options
    };
  }

  init() {
    const { stickyElement, velocity } = this.config;

    if (!stickyElement && !velocity) {
      return;
    }

    this.checkScrollPosition();
    window.addEventListener('scroll', this.checkScrollPosition.bind(this));
  }

  checkScrollPosition() {
    const { stickyElement, velocity } = this.config;
    const offset = stickyElement ? stickyElement.getBoundingClientRect().height : velocity;

    if (window.pageYOffset >= offset) {
      document.body.classList.add('is-sticky');
    } else {
      document.body.classList.remove('is-sticky');
    }
  }
}

export default Sticky;
